import CategoryTitle from '../../Basic/CategoryTitle/CategoryTitle.mjs';
import LineSeparator from '../../Basic/LineSeparator/LineSeparator.mjs';
import styled from 'styled-components';

const StyledCategoryLink = styled(CategoryTitle) `
  margin: 1.5rem 1rem;
`;
const StyledLineSeparator = styled(LineSeparator) `
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
`;

export { StyledCategoryLink, StyledLineSeparator };
//# sourceMappingURL=TopStories.styles.mjs.map
